import React, { useCallback, useRef } from "react";
import { Tooltip } from "antd";
import { ImageIcon } from "lucide-react";
import { MAX_IMAGES } from "../hooks/useImageAttachments";

interface AttachButtonProps {
    disabled: boolean;
    atMax: boolean;
    onFilesSelected: (files: File[]) => void;
}

const AttachButton: React.FC<AttachButtonProps> = ({ disabled, atMax, onFilesSelected }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files ?? []);
        e.target.value = ""; // reset so re-selecting the same file still fires onChange next time
        onFilesSelected(files); // stageFiles blocks it while a reply runs
    }, [onFilesSelected]);

    const disabledReason = disabled
        ? "Wait for the response to finish"
        : atMax
            ? `Max ${MAX_IMAGES} images per message`
            : undefined;

    return (
        <>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/png,image/jpeg,image/webp"
                multiple
                hidden
                onChange={handleFileInputChange}
            />
            <Tooltip title={disabledReason ?? "Upload Images (or drag & drop)"} overlayClassName="chat-v2-tooltip-sm">
                {/* A disabled native <button> doesn't fire mouseenter/mouseleave (HTML spec), so a
                    Tooltip wrapping it directly would never show. The wrapping <span> is antd's own
                    documented workaround. */}
                <span>
                    <button
                        type="button"
                        className="chat-v2-attach-icon-btn"
                        disabled={disabled || atMax}
                        aria-label="Attach image"
                        onClick={() => fileInputRef.current?.click()}
                    >
                        <ImageIcon size="1em" />
                    </button>
                </span>
            </Tooltip>
        </>
    );
};

export default AttachButton;
